import { render, staticRenderFns } from "./LeaguesList.vue?vue&type=template&id=4d2e6816&"
import script from "./LeaguesList.vue?vue&type=script&lang=ts&"
export * from "./LeaguesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports